import React, { useState, useEffect } from 'react';

import styles from '../raports/raports.module.scss';

import { Space } from '../../components/utils/utils';
import { getRaportsForInstitution } from '../../network/raports';
import { prettyDate } from '../../utils/strings';

import { Skeleton } from 'antd';
import CCollapseInstitution from '../../components/collapse/collapse-institution';
import { RootState } from '../../redux';
import { useAppSelector } from '../../redux/hooks';
import CCollapse from '../../components/collapse/collapse';
import { useGetSubordinateInstitutionsQuery } from '../../api';

const AdministrateRaports = () => {
  //   const [filterValue, setValue] = useState('');
  const [raports, setRaports] = useState([] as any[]);

  const institutions = useAppSelector(
    (state: RootState) => state.session.institutions
  );

  const { data: subordonateInstitutions } =
    useGetSubordinateInstitutionsQuery();

  const getRaports = async () => {
    setRaports([]);
    subordonateInstitutions?.data?.length > 0 &&
      (await subordonateInstitutions?.data?.forEach((institution: any) => {
        getRaportsForInstitution(+institution.id).then(({ data }) => {
          setRaports(list => [...list, { institution, data: data.rows }]);
        });
      }));
  };

  //   const handleFilter = (event: React.ChangeEvent<any>) => {
  //     const { value } = event.target;
  //     setValue(value);
  //   };

  //   const handleSort = (key: string) => {
  //     setSort(key);
  //   };

  //   //   useEffect(() => {
  //     const direction = sortValue === 'up' ? 1 : -1;
  //     const sorted = sort_chronologically(raports.data, 'createdAt', direction);

  //     setRaports({ ...raports, data: sorted });
  //     // eslint-disable-next-line
  //   }, [sortValue]);

  //   useEffect(() => {
  //     getRaports(currentPage);
  //   }, [currentPage]);

  //   useEffect(() => {
  //     const filtered =
  //       initial_raports &&
  //       initial_raports.data &&
  //       initial_raports.data.filter(
  //         (entry: IRaport) =>
  //           entry.createdAt
  //             .toString()
  //             .slice(0, 10)
  //             .toLowerCase()
  //             .includes(filterValue) ||
  //           prettyDate(entry.createdAt).toLowerCase().includes(filterValue)
  //       );

  //     setRaports({ ...raports, data: filtered });
  //     // eslint-disable-next-line
  //   }, [filterValue, initial_raports]);

  useEffect(() => {
    getRaports();
    // eslint-disable-next-line
  }, []);

  return (
    <div className={styles.container}>
      {raports && (
        <>
          <div className={styles.rowInfo}>
            <div className='column align-start '>
              <p className='subheading-dark bold'>
                Administrare rapoarte de control
              </p>
              <p className='body-dark'>
                {`Aveti ${raports.length} ${
                  raports.length === 1 ? 'instituție' : 'instituții'
                } subordonate.`}
              </p>
            </div>
          </div>
          <div className={styles.content}>
            {/* <div className='justify-start'> */}
            {/* <CSearchBar value={filterValue} onChange={handleFilter} /> */}
            {/* <Space horizontal={20} /> */}
            {/* <CSorting value={filterValue} onChange={handleSort} /> */}
            {/* </div> */}

            {raports && (
              <div className={styles.list}>
                {raports &&
                  raports.length > 0 &&
                  raports.map((entry: any) => (
                    <CCollapseInstitution
                      //   key={entry.institution.id}
                      //   id={entry.institution.id}
                      title={
                        <div className='column fullWidth'>
                          <p className='subheading-dark fullWidth bold'>{`Instituția 
                            ${entry.institution.name}`}</p>
                          <p className='body-dark thin'>
                            Această instituție a introdus{' '}
                            {entry.data && entry.data.length}{' '}
                            {entry.data && entry.data.length === 1
                              ? 'rapoart'
                              : 'raporte'}
                            .
                          </p>
                        </div>
                      }
                      institution={entry.institution}
                      details={'Vezi rapoarte'}
                    >
                      {entry.data &&
                        entry.data.map((raport: any) => (
                          <CCollapse
                            raport={raport}
                            title={`Raport introdus pe ${prettyDate(
                              raport.createdAt
                            )}`}
                            id={raport.id}
                          />
                        ))}
                      {entry.data && entry.data.length === 0 && (
                        <p className='body-dark faded'>
                          Această instituție nu a introdus niciun raport.
                        </p>
                      )}
                    </CCollapseInstitution>
                  ))}
              </div>
            )}
          </div>
          <Space vertical='1vh' />
        </>
      )}
      {!raports && <Skeleton />}
    </div>
  );
};

export default AdministrateRaports;
